import React from 'react';

const BackIcon = (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.70711 18.2929C9.09763 18.6834 9.09763 19.3166 8.70711 19.7071C8.31658 20.0976 7.68342 20.0976 7.29289 19.7071L0.792893 13.2071C0.402369 12.8166 0.402369 12.1834 0.792893 11.7929L7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289C9.09763 5.68342 9.09763 6.31658 8.70711 6.70711L3.91421 11.5H22C22.5523 11.5 23 11.9477 23 12.5C23 13.0523 22.5523 13.5 22 13.5H3.91421L8.70711 18.2929Z"
      fill="#1F1E1E"
    />
  </svg>
);

export default BackIcon;
